<script>
  import currentIdx from '../store/currentIdx';
  import fieldValues from '../store/fieldValues';
  import Form from '../components/Form.svelte';
  import SelectField from '../components/SelectField.svelte';
  import InputField from '../components/InputField.svelte';

  export let title;
  export let description;
</script>

<Form
  {title}
  {description}
  handlePrevious={currentIdx.decrementIndex}
  handleNext={currentIdx.incrementIndex}
  isDisabled={!$fieldValues['job'] || !$fieldValues['element']}>
  <InputField
    label="NickName"
    placeholder="Cliff"
    value={$fieldValues['nickName'] || ''}
    on:input={e => fieldValues.setField('nickName', e.detail.value)} />
  <SelectField
    label="Job"
    options={['Bowman', 'Knight', 'Paladin', 'Wizard']}
    value={$fieldValues['job'] || ''}
    isRequired
    on:input={e => fieldValues.setField('job', e.detail.value)} />
  <SelectField
    label="Element"
    options={['Fire', 'Rock', 'Earth', 'Wind', 'Water', 'Ice', 'Lightning']}
    value={$fieldValues['element'] || ''}
    isRequired
    on:input={e => fieldValues.setField('element', e.detail.value)} />
</Form>
